<template>
<div>

	<!--<component is="style">
		body::before {
		    background-image: url({{background}});
		}
	</component>-->

	<div v-if="songs.length === 0" class="loading-songs">

		<div class="center">
			<img src="/images/Book.gif">
			<h1>Завантажуємо...</h1>
		</div>
		
	</div>

	<header>
      <div class="container">
        <div class="menu">
          <div>
           
          </div>

          <div style="text-align: center;">

          	<router-link :to="{ path: '/zmist' }"><img src="/images/logo.png" class="book-logo"></router-link>
            
          </div> 

          <div style="text-align: right;"> 

          	 <router-link v-if="$route.path != '/zmist'" :to="{ path: '/zmist' }">
          	 	<img src="/images/content.svg" height="50">
          	 </router-link>

          	 <a v-else @click="$router.go(-1)">
          	 	<img src="/images/content.svg" height="50">
          	 </a>

          </div>
        </div>
      </div>
    </header>

     <div class="container main">

	<div class="wrapper">
      
		<div class="center" v-if="$route.path != '/zmist'">
	  	<span class="block settings">
	  		Слухати всю книжку <toggle-button style="margin-left: 5px; margin-top: -3px;" :height="24" :width="55" @change="AutoPlay" v-model="auto" color="#ce911e"/>
	  	</span>
	  </div>

	  	<div v-if="$route.path != '/zmist'" class="block center">

	  		<h1 v-if="$route.path != '/zmist' && $route.path != '/obkl'">{{ song.name }}</h1>
		    <!--<div class="authors">{{ song.authors }}</div>-->
		    <div v-for="image in song.images" :key="song.image" class="illustration">

		    	<!--<img id="image" :src="'/images/illustrations/'+image+'.jpg'">-->
		    	<img id="image" :src="'/images/illustrations/o.jpg'">

		    </div>


		</div>

		<audio id="player" @timeupdate="progressUpdate">
	    	<source v-if="song.music != 'mp3/'" :src="song.music" type="audio/mpeg">
	  	</audio>

 
		<div v-if="$route.path != '/zmist'" class="block">

			<div v-html="song.information" class="text"></div>

		</div> 

		<div v-if="$route.path == '/zmist' || $route.path == '/obkl'" class="block" v-bind:class="[$route.path == '/zmist' ? 'z' : '']">

      		<div class="content" style="padding-bottom: 50px;">

      			<div v-for="song in songs" :key="song.song" v-if="song.song != 55 && song.song != 0 && song.song != 101 && song.song != 102 && song.song != 103">
			  		<router-link :to="{ path: song.slug }">{{ song.name }}</router-link><hr v-if="song.song != 8">
			  	</div>
  				
  			</div>

  		</div>

		<div v-show="$route.path != '/zmist'" class="block-player">
			<div class="block-bar">
		    	<div class="bar-border">
		      		<div class="bar-duration" id="duration" @mousedown="update">
				        <div class="bar-position" id="position"></div>
				        <div class="bar-position-load" id="loading"></div>
		        	</div>
		      </div>
		    </div>

		      
		    <div class="player-controls center">
		    	<div id="column-2" style="text-align: left;">
		    		{{ status }}
		    	</div>
		    	<div id="column-2">
		    		<img @click="Prew" src="@/assets/prew.svg" style="text-align: right;" width="24">
		    	</div>
				<div>

				<div class="player-buttom" id="buttom" @click="Play">
		      		<img src="@/assets/play.svg" width="48">
		    	</div>
		      		
		   		</div>
			   	<div id="column-2">
			    	<img @click="Next" src="@/assets/next.svg" width="24">
			        
			   	</div>
			   	<div id="column-2" style="text-align: right;">{{ duration }}</div>
		    </div>
		    
	  	</div>

	  	<div class="center footer">
	  		<!--<small>Усі права застережено</small><br />--><!--© <a target="_blank" href="http://ababahalamaha.com.ua">«А-БА-БА-ГА-ЛА-МА-ГА»</a> 2022-->
	  	</div>

	  </div>

	</div>
   </div> 
</template>


<script>

export default {
  
  data() {
    return {
    	auto: false,
	    show: true,
	    block1: 'hd',
	    play: 0,
	    status: '0:00',
	    player_buttom: 'p_play',
	    duration: '0:00',
	    text: false,
	    songs: [],
	    position: 0,
	    background: '/images/Forzac_1.jpg',
	    process: 'p_play',
	    song: {
	    	slug:"/main",
			name:"",
			authors:"",
			image:"images/none.jpg",
			music:"mp3/",
			information:"" },
	}    
  },

  components: {
    'p_play': {
      template: '<img src="@/assets/play.svg" width="48">'
    },
    'p_pause': {
      template: '<img src="@/assets/pause.svg" width="48">'
    }, 
  },

  mounted () {

  	if (this.song.music != 0) {
     
	    var vid = document.getElementById("player");

		vid.onplay = function() {
		    document.getElementById('buttom').innerHTML = '<img src="/images/pause.svg" width="48">';
		}; 


		vid.onpause = function() {
		    document.getElementById('buttom').innerHTML = '<img src="/images/play.svg" width="48">';
		};


		vid.onwaiting = function() {
		    document.getElementById('buttom').innerHTML = '<img src="/images/loading.svg" width="48">';
		};
		/*/
		vid.onloadeddata = function() {
		    document.getElementById('buttom').innerHTML = '<img src="images/play.svg" width="32">';
		}; 
		*/
		vid.onplaying = function() {
		    document.getElementById('buttom').innerHTML = '<img src="/images/pause.svg" width="48">';
		}; 

	}

  },
  created: function() {

   // this.Animation('name_logo');
  
  
  //this.PlayerLoad()

   this.$http.get('/songs.json?'+Math.floor(Math.random() * Math.floor(9999))).then(function (response) { 

   		this.songs = response.data 

    	var pos = this.songs.find( song => song.slug === this.$route.path )

	    if (!pos) this.$router.push({ path: '/zmist' })

	    this.position = Number(pos.song);

	    this.song = this.songs.find( id => id.song === String(this.position) )

	    document.title = this.song.name

	    if (this.song.music != 0) {

		    player.src = this.song.music
		   	this.PlayerLoad()

	   }




  }).catch(function (error) {});

    if (this.getCookie('autoplay') == 'true') {
    	this.auto = true

    } else {
    	this.auto = false
    }

  },

  watch: {
    '$route' (to, from) {

	    var pos = this.songs.find( song => song.slug === this.$route.path )

	    if (!pos) this.$router.push({ path: '/zmist' })

	    this.position = Number(pos.song);

	    this.song = this.songs.find( id => id.song === String(this.position) )

	    document.title = this.song.name

	    document.getElementById('player').pause();
	    this.play = 0;


	    if (this.song.music != 0) {

			player.src = this.song.music
			this.PlayerLoad()

		}

		if (this.background == '/images/Forzac_1.jpg') {
			this.background = '/images/Forzac_2.jpg'
		} else {
			this.background = '/images/Forzac_1.jpg'
		}

		

	    //console.log(this.position)

    }
  },
  
  methods: {

  	AutoPlay() {

  		if (this.auto) {
  			document.cookie = "autoplay=true; expires=Tue, 19 Jan 2038 03:14:07 GMT";
  			//console.log('0')
  		} else {
  			document.cookie = "autoplay=false; expires=Tue, 19 Jan 2038 03:14:07 GMT";
  			//console.log('1')
  		}

  	},

  	getCookie(name) {
	  let matches = document.cookie.match(new RegExp(
	    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	  ));
	  return matches ? decodeURIComponent(matches[1]) : undefined;
	},

    PlayerLoad() {

	   // console.log('preLoad - '+player.src)

	    let p = document.getElementById('player')

	     if (this.auto) {
		    this.Play()
		} else {
		    document.getElementById('buttom').innerHTML = '<img src="/images/play.svg" width="48">';
		}

	    /* Google Analytics */
	    /*this.$ga.event({
			eventCategory: 'song',
			eventAction: 'listening',
			eventLabel: this.song.name+' - '+this.$route.path,
			eventValue: 1
		})*/

	    setTimeout(() => this.Duration(), 300);

  		//console.log(p.duration)

    },

    Duration() {

    	if (this.$route.path !== '/zmist') {

	    	let p = document.getElementById('player')

	    	//console.log('duration load... ')

	    	if (!p.duration) {
	      	// this.player_buttom = 'p_loading';
	      		return setTimeout(() => this.Duration(), 1000);
	    	}

	    	var h = p.duration.toFixed() / 3600 ^ 0;
		    var m = (p.duration.toFixed() - h * 3600) / 60 ^ 0;
		    var s = p.duration.toFixed() - h * 3600 - m * 60;
		    let sec = (s<10?"0"+s:s);
		  
		    this.duration = (m<10?""+m:m)+":"+sec;

		   	this.progressUpdate()

	   }

    },    

    Play() {


    	if (document.getElementById('player').paused) {

       		// this.PlayerLoad()
	      	document.getElementById('player').play();
	      	this.play = 1;
	     	//his.process = 'p_pause';
	      	//console.log('play');

	    } else {

	      	document.getElementById('player').pause();
	      	this.play = 0;
	     	//his.process = 'p_play'
	      	//console.log('pause');

	    }


   		// this.player_buttom =  this.process;

    },

    Prew: function() {

    	if (this.position == 1) {
	      this.position = 8
	    } else {
	      this.position--
	    }


	    let prew = this.songs.find( id => id.song === String(this.position) )
	    this.$router.push({ path: prew.slug })

    },	

    Next() {

	    if (this.position >= 8) {
	      this.position = 1
	    } else {
	      this.position++
	    }

	    let next = this.songs.find( id => id.song === String(this.position) )
	    this.$router.push({ path: next.slug })

    },

   	progressUpdate() {

   		var positionBar = document.getElementById("position");
   		positionBar.style.width = (player.currentTime / player.duration * 100)  + "%";

   		var r = player.buffered;

  		if (r) {
    		for (var i=0; i<r.length; i++) {
      			var start = r.start(i)/player.duration * 100;
      			var end = r.end(i)/player.duration * 100;
      			var loadingBar = document.getElementById("loading");
    			loadingBar.style.width = Math.max(2, end-start).toFixed(4) + "%";
    		}
  		}


	    var h = player.currentTime.toFixed() / 3600 ^ 0;
	    var m = (player.currentTime.toFixed() - h * 3600) / 60 ^ 0;
	    var s = player.currentTime.toFixed() - h * 3600 - m * 60;
	    let sec = (s<10?"0"+s:s);
	  
	    this.status = (m<10?""+m:m)+":"+sec;


	    if (player.ended) {

	    	this.play = 0;
	      	this.player_buttom = 'p_play';

			if (this.auto) {

				this.Next()

			}
	    }

  	},

	update($event) {

		let d = document.getElementById("duration")
	    let perPixel = player.duration / d.clientWidth;
	    let x = $event.pageX - d.offsetLeft;
	    let dd = x * perPixel

	    player.currentTime = dd.toFixed(3)

	    var positionBar = document.getElementById("position");
	    positionBar.style.width = (dd.toFixed(3) / player.duration * 100)  + "%";

	    //console.log(dd.toFixed(3)+" - "+player.duration);

	  }
   }

 }
</script>